import getters from './getters'

 const structure = {
    namespaced: true,
    strict: process.env.NODE_ENV !== 'production',
    state: {
      meterConsumptionFields: [
        { id: "id", name: "Id записи", default: false },
        { id: "idMeter", name: "Id прибора учета", default: false },
        { id: "meterSerialNumber", name: "Номер прибора учета", default: true },
        { id: "meterType", name: "Тип прибора учета", default: true },
        { id: "meterTradeMark", name: "Марка прибора учета", default: true },
        { id: "meterDiameter", name: "Диаметр прибора учета", default: true },
        { id: "idNode", name: "Id объекта", default: false },
        { id: "idPeriodType", name: "Id периода записи", default: false },   
        { id: "periodType", name: "Период записи", default: true },             
        { id: "periodPublicCode", name: "Код типа периода", default: false },
        { id: "dateStatement", name: "Дата показания", default: true },
        { id: "dateAsqusition", name: "Дата опроса устройства", default: false },
        { id: "isCalculated", name: "Признак автоматического расчета", default: false },
        { id: "isDeleted", name: "Признак удаления", default: false },        
        { id: "consumption", name: "Значение потребления", default: true }        
      ],

      meterStatementFields: [
        { id: "id", name: "Id записи", default: false },
        { id: "idMeter", name: "Id прибора учета", default: false },
        { id: "meterSerialNumber", name: "Номер прибора учета", default: true },
        { id: "meterType", name: "Тип прибора учета", default: true },
        { id: "meterTradeMark", name: "Марка прибора учета", default: true },
        { id: "meterDiameter", name: "Диаметр прибора учета", default: true },
        { id: "idNode", name: "Id объекта", default: false },
        { id: "idRecordType", name: "Id типа записи", default: false },
        { id: "recordType", name: "Тип записи", default: true },
        { id: "recordTypePublicCode", name: "Код типа записи", default: false },
        { id: "dateStatement", name: "Дата показания", default: true },
        { id: "dateAsqusition", name: "Дата опроса устройства", default: false },
        { id: "isDeleted", name: "Признак удаления", default: false },
        { id: "pulses", name: "Количество импульсов", default: false },
        { id: "statement", name: "Показание прибора учета", default: true },
        { id: "consumption", name: "Мгновенный расход прибора учета", default: true },
        { id: "state", name: "Статус датчика", default: true },
        { id: "pulseWeight", name: "Цена импульса", default: false },
        { id: "correction", name: "Значение коррекции", default: false }
      ],

      thermalMeterConsumptionFields: [
        { id: "id", name: "Id записи", default: false },
        { id: "idMeter", name: "Id прибора учета", default: false },
        { id: "meterSerialNumber", name: "Номер прибора учета", default: true },
        { id: "meterType", name: "Тип прибора учета", default: true },
        { id: "meterTradeMark", name: "Марка прибора учета", default: true },
        { id: "idNode", name: "Id объекта", default: false },
        { id: "idPeriodType", name: "Id периода записи", default: false },   
        { id: "periodType", name: "Период записи", default: true },             
        { id: "periodPublicCode", name: "Код типа периода", default: false },
        { id: "dateStatement", name: "Дата показания", default: true },
        { id: "dateAsqusition", name: "Дата опроса устройства", default: false },
        { id: "isCalculated", name: "Признак автоматического расчета", default: false },
        { id: "isDeleted", name: "Признак удаления", default: false },
        { id: "energySum", name: "Полная тепловая энергия", default: true },
        { id: "energyOutput", name: "Энергия отопления", default: true },
        { id: "energyHotWater", name: "Энергия ГВС", default: true },
        { id: "weightInput", name: "Полученная масса воды", default: true },
        { id: "weightOutput", name: "Возвращенная масса воды", default: true },
        { id: "weightHotWater", name: "Израсходованная масса воды", default: true },
        { id: "tempInput", name: "Средняя температура полученной воды ", default: true },
        { id: "tempOutput", name: "Средняя температура возвращенной воды ", default: true },
        { id: "tempDelta", name: "Разность температур отопления", default: true },
        { id: "tempRecharge", name: "Температура подпиточной воды", default: false },
        { id: "pressureInput", name: "Давление воды на входе", default: false },
        { id: "pressureOutput", name: "Давление воды на выходе", default: false },
        { id: "timeWork", name: "Время в исправном состоянии", default: true },
        { id: "timeError", name: "Время в неисправном состоянии", default: true },
        { id: "errorCode", name: "Условный код неисправности", default: true }
      ],

      thermalMeterStatementFields: [
        { id: "id", name: "Id записи", default: false },
        { id: "idMeter", name: "Id прибора учета", default: false },
        { id: "meterSerialNumber", name: "Номер прибора учета", default: true },
        { id: "meterType", name: "Тип прибора учета", default: true },
        { id: "meterTradeMark", name: "Марка прибора учета", default: true },
        { id: "idNode", name: "Id объекта", default: false },
        { id: "idRecordType", name: "Id типа записи", default: false },
        { id: "recordType", name: "Тип записи", default: true },
        { id: "recordTypePublicCode", name: "Код типа записи", default: false },
        { id: "dateStatement", name: "Дата показания", default: true },
        { id: "dateAsqusition", name: "Дата опроса устройства", default: false },
        { id: "isDeleted", name: "Признак удаления", default: true },
        { id: "energySum", name: "Полная тепловая энергия", default: true },
        { id: "energyOutput", name: "Энергия отопления", default: true },
        { id: "energyHotWater", name: "Энергия ГВС", default: true },
        { id: "weightInput", name: "Полученная масса воды", default: true },
        { id: "weightOutput", name: "Возвращенная масса воды", default: true },
        { id: "weightHotWater", name: "Израсходованная масса воды", default: true },
        { id: "tempInput", name: "Средняя температура полученной воды ", default: true },
        { id: "tempOutput", name: "Средняя температура возвращенной воды ", default: true },
        { id: "tempDelta", name: "Разность температур отопления", default: true },
        { id: "tempRecharge", name: "Температура подпиточной воды", default: false },
        { id: "pressureInput", name: "Давление воды на входе", default: false },
        { id: "pressureOutput", name: "Давление воды на выходе", default: false },
        { id: "timeWork", name: "Время в исправном состоянии", default: true },
        { id: "timeError", name: "Время в неисправном состоянии", default: true },
        { id: "errorCode", name: "Условный код неисправности", default: true }
      ],
      
      exportMeterStatementFields: [
        { id: "companyName", name: "Компания", default: false },
        { id: "fullAddress", name: "Полный адрес", default: false },
        { id: "shortAddress", name: "Адрес", default: true },
        { id: "clientName", name: "Потребитель", default: true },
        { id: "serialNumber", name: "Номер прибора учета", default: true },
        { id: "meterEnergyType", name: "Тип энергоносителя прибора учета", default: false },
        { id: "meterTradeMark", name: "Марка прибора учета", default: true },
        { id: "meterType", name: "Тип прибора учета", default: true },
        { id: "meterDiameter", name: "Диаметр прибора учета", default: true },
        { id: "personalAccount", name: "Лицевой счет", default: true },
        { id: "contractColdWater", name: "Номер договора по холодной воде", default: true },
        { id: "contractHeat", name: "Номер договора по теплу", default: true },
        { id: "contractElectricity", name: "Номер договора по электричеству", default: false },
        { id: "contractGas", name: "Номер договора по газу", default: false },
        { id: "transportSerialNumber", name: "Серийный номер радиомодуля", default: true },
        { id: "transportChannelName", name: "Тип канала связи", default: true },
        { id: "transportChanelNumber", name: "Номер канала", default: true },
        { id: "networkAddress", name: "Сетевой адрес", default: true },
        { id: "creationDate", name: "Дата создания прибора учета", default: false },
        { id: "checkingDate", name: "Дата следующей поверки", default: false },
        { id: "modifiedDate", name: "Дата редактирования", default: false },
        { id: "plombNumber", name: "Номер пломбы", default: false },
        { id: "initialStatement", name: "Начальные показания", default: false },
        { id: "objectAdditionalInfo", name: "Дополнительная информация по объекту", default: false },
        { id: "meterAdditionalInfo", name: "Дополнительная информация по прибору учета", default: false },
        { id: "recordType", name: "Тип записи", default: true },
        { id: "dateStatement", name: "Дата показания", default: true },
        { id: "dateAsqusition", name: "Дата опроса устройства", default: false },
        { id: "pulses", name: "Количество импульсов", default: false },
        { id: "statement", name: "Показание прибора учета", default: true },
        { id: "consumption", name: "Мгновенный расход прибора учета", default: true },
        { id: "state", name: "Статус датчика", default: true },
        { id: "pulseWeight", name: "Цена импульса", default: false },
        { id: "correction", name: "Значение коррекции", default: false }
      ],

      exportMeterConsumptionFields: [
        { id: "companyName", name: "Компания", default: false },
        { id: "fullAddress", name: "Полный адрес", default: false },
        { id: "shortAddress", name: "Адрес", default: true },
        { id: "clientName", name: "Потребитель", default: true },
        { id: "serialNumber", name: "Номер прибора учета", default: true },
        { id: "meterEnergyType", name: "Тип энергоносителя прибора учета", default: false },
        { id: "meterTradeMark", name: "Марка прибора учета", default: true },
        { id: "meterType", name: "Тип прибора учета", default: true },
        { id: "meterDiameter", name: "Диаметр прибора учета", default: true },
        { id: "personalAccount", name: "Лицевой счет", default: true },
        { id: "contractColdWater", name: "Номер договора по холодной воде", default: true },
        { id: "contractHeat", name: "Номер договора по теплу", default: true },
        { id: "contractElectricity", name: "Номер договора по электричеству", default: false },
        { id: "contractGas", name: "Номер договора по газу", default: false },
        { id: "transportSerialNumber", name: "Серийный номер радиомодуля", default: true },
        { id: "transportChannelName", name: "Тип канала связи", default: true },
        { id: "transportChanelNumber", name: "Номер канала", default: true },
        { id: "networkAddress", name: "Сетевой адрес", default: true },
        { id: "creationDate", name: "Дата создания прибора учета", default: false },
        { id: "checkingDate", name: "Дата следующей поверки", default: false },
        { id: "modifiedDate", name: "Дата редактирования", default: false },
        { id: "plombNumber", name: "Номер пломбы", default: false },
        { id: "initialStatement", name: "Начальные показания", default: false },
        { id: "objectAdditionalInfo", name: "Дополнительная информация по объекту", default: false },
        { id: "meterAdditionalInfo", name: "Дополнительная информация по прибору учета", default: false },
        { id: "periodType", name: "Период архива", default: true },
        { id: "dateStatement", name: "Дата показания", default: true },
        { id: "dateAsqusition", name: "Дата опроса устройства", default: false },
        { id: "isCalculated", name: "Авторасчет", default: false },
        { id: "consumption", name: "Значение потребления прибора учета", default: true },
      ],

      exportThermalMeterStatementFields: [
        { id: "companyName", name: "Компания", default: false },
        { id: "fullAddress", name: "Полный адрес", default: false },
        { id: "shortAddress", name: "Адрес", default: true },
        { id: "clientName", name: "Потребитель", default: true },
        { id: "serialNumber", name: "Номер прибора учета", default: true },
        { id: "meterEnergyType", name: "Тип энергоносителя прибора учета", default: false },
        { id: "meterTradeMark", name: "Марка прибора учета", default: true },
        { id: "meterType", name: "Тип прибора учета", default: true },
        { id: "personalAccount", name: "Лицевой счет", default: true },
        { id: "contractColdWater", name: "Номер договора по холодной воде", default: true },
        { id: "contractHeat", name: "Номер договора по теплу", default: true },
        { id: "contractElectricity", name: "Номер договора по электричеству", default: false },
        { id: "contractGas", name: "Номер договора по газу", default: false },
        { id: "transportSerialNumber", name: "Серийный номер радиомодуля", default: true },
        { id: "transportChannelName", name: "Тип канала связи", default: true },
        { id: "transportChanelNumber", name: "Номер канала", default: true },
        { id: "networkAddress", name: "Сетевой адрес", default: true },
        { id: "creationDate", name: "Дата создания прибора учета", default: false },
        { id: "checkingDate", name: "Дата следующей поверки", default: false },
        { id: "modifiedDate", name: "Дата редактирования", default: false },
        { id: "plombNumber", name: "Номер пломбы", default: false },
        { id: "initialStatement", name: "Начальные показания", default: false },
        { id: "objectAdditionalInfo", name: "Дополнительная информация по объекту", default: false },
        { id: "meterAdditionalInfo", name: "Дополнительная информация по прибору учета", default: false },
        { id: "recordType", name: "Тип записи", default: true },
        { id: "dateStatement", name: "Дата показания", default: true },
        { id: "dateAsqusition", name: "Дата опроса устройства", default: false },
        { id: "energySum", name: "Полная тепловая энергия", default: true },
        { id: "energyOutput", name: "Энергия отопления", default: true },
        { id: "energyHotWater", name: "Энергия ГВС", default: true },
        { id: "weightInput", name: "Полученная масса воды", default: true },
        { id: "weightOutput", name: "Возвращенная масса воды", default: true },
        { id: "weightHotWater", name: "Израсходованная масса воды", default: true },
        { id: "tempInput", name: "Средняя температура полученной воды ", default: true },
        { id: "tempOutput", name: "Средняя температура возвращенной воды ", default: true },
        { id: "tempDelta", name: "Разность температур отопления", default: true },
        { id: "tempRecharge", name: "Температура подпиточной воды", default: false },
        { id: "pressureInput", name: "Давление воды на входе", default: false },
        { id: "pressureOutput", name: "Давление воды на выходе", default: false },
        { id: "timeWork", name: "Время в исправном состоянии", default: true },
        { id: "timeError", name: "Время в неисправном состоянии", default: true },
        { id: "errorCode", name: "Условный код неисправности", default: true }
      ],

      exportThermalMeterConsumptionFields: [
        { id: "companyName", name: "Компания", default: false },
        { id: "fullAddress", name: "Полный адрес", default: false },
        { id: "shortAddress", name: "Адрес", default: true },
        { id: "clientName", name: "Потребитель", default: true },
        { id: "serialNumber", name: "Номер прибора учета", default: true },
        { id: "meterEnergyType", name: "Тип энергоносителя прибора учета", default: false },
        { id: "meterTradeMark", name: "Марка прибора учета", default: true },
        { id: "meterType", name: "Тип прибора учета", default: true },
        { id: "personalAccount", name: "Лицевой счет", default: true },
        { id: "contractColdWater", name: "Номер договора по холодной воде", default: true },
        { id: "contractHeat", name: "Номер договора по теплу", default: true },
        { id: "contractElectricity", name: "Номер договора по электричеству", default: false },
        { id: "contractGas", name: "Номер договора по газу", default: false },
        { id: "transportSerialNumber", name: "Серийный номер радиомодуля", default: true },
        { id: "transportChannelName", name: "Тип канала связи", default: true },
        { id: "transportChanelNumber", name: "Номер канала", default: true },
        { id: "networkAddress", name: "Сетевой адрес", default: true },
        { id: "creationDate", name: "Дата создания прибора учета", default: false },
        { id: "checkingDate", name: "Дата следующей поверки", default: false },
        { id: "modifiedDate", name: "Дата редактирования", default: false },
        { id: "plombNumber", name: "Номер пломбы", default: false },
        { id: "initialStatement", name: "Начальные показания", default: false },
        { id: "objectAdditionalInfo", name: "Дополнительная информация по объекту", default: false },
        { id: "meterAdditionalInfo", name: "Дополнительная информация по прибору учета", default: false },
        { id: "periodType", name: "Период архива", default: true },
        { id: "dateStatement", name: "Дата показания", default: true },
        { id: "dateAsqusition", name: "Дата опроса устройства", default: false },
        { id: "isCalculated", name: "Авторасчет", default: false },
        { id: "energySum", name: "Полная тепловая энергия", default: true },
        { id: "energyOutput", name: "Энергия отопления", default: true },
        { id: "energyHotWater", name: "Энергия ГВС", default: true },
        { id: "weightInput", name: "Полученная масса воды", default: true },
        { id: "weightOutput", name: "Возвращенная масса воды", default: true },
        { id: "weightHotWater", name: "Израсходованная масса воды", default: true },
        { id: "tempInput", name: "Средняя температура полученной воды ", default: true },
        { id: "tempOutput", name: "Средняя температура возвращенной воды ", default: true },
        { id: "tempDelta", name: "Разность температур отопления", default: true },
        { id: "tempRecharge", name: "Температура подпиточной воды", default: false },
        { id: "pressureInput", name: "Давление воды на входе", default: false },
        { id: "pressureOutput", name: "Давление воды на выходе", default: false },
        { id: "timeWork", name: "Время в исправном состоянии", default: true },
        { id: "timeError", name: "Время в неисправном состоянии", default: true },
        { id: "errorCode", name: "Условный код неисправности", default: true }
      ],
    },
    getters,
  }

  export default structure